import { CompactButton } from '@/components/buttons';
import { ContentPanel } from '@/components/content-panel';
import { CurbyAccordion } from '@/components/curby-accordion';
import { PrimaryLayout } from '@/layouts/primary';
import { TopNavFor } from '@/layouts/primary/top-nav';
import { IconHelpCircle } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { AccordionLocation } from '../../../../backend/src/types.generated';
import { Header } from './header';

export const RewardsPage = () => {
	const navigate = useNavigate();

	const helpButton = useMemo(
		() => (
			<CompactButton leftSection={<IconHelpCircle />} onClick={() => navigate({ to: '/help' })}>
				Help
			</CompactButton>
		),
		[navigate]
	);

	return (
		<PrimaryLayout
			bottomNav="home"
			header={{ title: 'Entries & Rewards', children: helpButton }}
			topNav={TopNavFor.ENTRIES_AND_REWARDS}
		>
			<ContentPanel>
				<Header />
				<CurbyAccordion
					title="How it works"
					accordionLocation={AccordionLocation.RewardsHowItWorks}
				/>
				<CurbyAccordion
					title="Terms and Conditions"
					accordionLocation={AccordionLocation.RewardsTsAndCs}
				/>
			</ContentPanel>
		</PrimaryLayout>
	);
};
